import { Component } from '@angular/core';
import { MenuItemComponent } from "./menu-item/menu-item.component";
import { CommonModule } from '@angular/common';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { MenuService } from 'src/app/services/menu/menu.service';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { LanguageService } from 'src/app/services/language/language.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorComponent } from "../../layout/error/error.component";



@Component({
  selector: 'app-menu-manager',
  imports: [MenuItemComponent, CommonModule, DragDropModule, FormsModule, SpinnerComponent, ErrorComponent],
  templateUrl: './menu-manager.component.html',
  styleUrl: './menu-manager.component.css'
})
export class MenuManagerComponent {

  menuItems: any
  selectedMenu: 'top' | 'bottom' = 'top';
  load = false
  loadSave = false

  error = false

  isDrangDrop = false

  currentLang = 'ge'

  constructor(
    private MenuService: MenuService, 
    private langService: LanguageService,
    private ToastrService: ToastrService
  ){

    this.currentLang = this.langService.getLanguage();

    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
        this.getMenu()
    });

    this.getMenu()

  }

  getMenu(){
    this.load = true
    this.MenuService.getMenu().subscribe(
      (res: any) => {
        this.load = false
        this.menuItems = res[this.selectedMenu];
        // console.log(this.menuItems)
        this.error = false
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    );
  }

  onMenuChange(){
    this.getMenu();
  }

  save() {
    this.loadSave = true
    const prepared = this.menuItems.map((item: any, index: number) => this.prepareItem(item, index));
    this.MenuService.saveMenu(prepared).subscribe(
      () => {
        this.loadSave = false
        this.ToastrService.success('შენახულია!')
        this.isDrangDrop = false
      },
      () => {
        this.loadSave = false
        this.ToastrService.error('შეცდომა!')
      }
    );
  }

  prepareItem(item: any, index: number) {
    return {
      id: item.id,
      order: index,
      menutitle: item.menutitle,
      visibility: item.visibility ? 1 : 0,
      children: item.children?.map((child: any, childIndex: number) => ({
        id: child.id,
        order: childIndex,
        title: child.title,
        visibility: child.visibility ? 1 : 0,
      })) || [],
    };
  }

  drop(event: CdkDragDrop<any[]>) {
    // console.log('From:', event.previousIndex, 'To:', event.currentIndex);
    // console.log('Before:', JSON.parse(JSON.stringify(this.menuItems)));
    moveItemInArray(this.menuItems, event.previousIndex, event.currentIndex);
    this.menuItems.forEach((item: any, index: number) => {
      item.order = index;
    });
    this.menuItems.sort((a: any, b: any) => a.order - b.order);
    // console.log('After:', this.menuItems);
    this.isDrangDrop = true
  }

    trackById(index: number, item: any): number {
      return item.id;
    }

    onUpdate(){

    }

  

}
